export default "__VITE_ASSET__e3c88478__"